import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { OfflineDatabaseReferenceColor } from '../database/offlineDatabase/types/offlineDatabaseReferenceColor.types';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';
import { createOfflineFilterOptionsRepository } from './filterOptions/createOfflineFilterOptionsRepository';

const commonRepository = createOfflineCommonRepository<OfflineDatabaseReferenceColor, 'id'>(
  () => offlineDatabase.referenceColors,
);

const filterOptionsRepository = createOfflineFilterOptionsRepository<
  OfflineDatabaseReferenceColor,
  'id'
>(() => offlineDatabase.referenceColors, ['name']);

export const offlineReferenceColorsRepository = { ...commonRepository, ...filterOptionsRepository };
